/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StudentMetaAvailableCAT2122Data from './StudentMetaAvailableCAT2122Data';

/**
 * The StudentMetaAvailableCAT2122 model module.
 * @module model/StudentMetaAvailableCAT2122
 * @version 1.0.0
 */
class StudentMetaAvailableCAT2122 {
    /**
     * Constructs a new <code>StudentMetaAvailableCAT2122</code>.
     * @alias module:model/StudentMetaAvailableCAT2122
     */
    constructor() { 
        
        StudentMetaAvailableCAT2122.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentMetaAvailableCAT2122</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentMetaAvailableCAT2122} obj Optional instance to populate.
     * @return {module:model/StudentMetaAvailableCAT2122} The populated <code>StudentMetaAvailableCAT2122</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentMetaAvailableCAT2122();

            if (data.hasOwnProperty('availableToFinish')) {
                obj['availableToFinish'] = ApiClient.convertToType(data['availableToFinish'], 'Boolean');
            }
            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], [StudentMetaAvailableCAT2122Data]);
            }
        }
        return obj;
    }


}

/**
 * Indica si el alumno puede finalizar su ciclo en CAT2122 (true = puede, false = no puede)
 * @member {Boolean} availableToFinish
 */
StudentMetaAvailableCAT2122.prototype['availableToFinish'] = undefined;

/**
 * Datos de los ciclos
 * @member {Array.<module:model/StudentMetaAvailableCAT2122Data>} data
 */
StudentMetaAvailableCAT2122.prototype['data'] = undefined;






export default StudentMetaAvailableCAT2122;

